module.exports = __webpack_public_path__ + "img/r21.4324a607.png";